import { CQLGeoserver } from "./CQLGeoserver.js";

export { CQLEsri }

class CQLEsri extends CQLGeoserver {

    static getFilterParams(harmonizedFilters, layerName) {
        const filter = super.getFilterParams(harmonizedFilters);

        if (filter.cql_filter) {
            const layerDefs = {};
            layerDefs[layerName] = filter.cql_filter;
            return { layerDefs: JSON.stringify(layerDefs) };
        }

        return {};
    }

}